let oatState = {
  isOAT: false,
  OATConfig: {},
};

export const setOATState = (state) => {
  oatState = state;
};

export const getOATState = () => oatState;